import React from 'react';
import TextareaEmailsField from 'components/TextareaEmailsField';
import TextAreaField from 'components/TextAreaField';
import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import CircledExclamationmarkIcon from 'icons/CircledExclamationmark.icon';
import { RfiCreateStep } from '../../utils';

import './StepShare.styles.scss';

const BASE = 'step-share';

const StepShare: React.FC<RfiCreateStep> = ({
  isCreatingOrEditingTemplate,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {isCreatingOrEditingTemplate ? null : (
        <>
          <div className={`${BASE}__note`}>
            <CircledExclamationmarkIcon />
            <p>{t('shareNote')}</p>
          </div>
          <span />

          <Field
            name="recipients"
            label={t('recipients')}
            component={TextareaEmailsField}
            className={`${BASE}__recipients`}
            description={t('rfiEmailsDescription')}
          />
        </>
      )}

      <Field
        label={t('addCustomNoteRecipients')}
        name="customNote"
        component={TextAreaField}
        maxLength={1000}
        className={`${BASE}__textarea`}
      />
    </>
  );
};

export default StepShare;
